import { Link, useMatch, useResolvedPath } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <>
      <nav className="footer">
        <ul className={`footer-list`}>
          <CustomLink to="/ ">© Hawks Eats</CustomLink>
          <CustomLink to="/about ">About</CustomLink>
          <CustomLink to="/terms-and-conditions">Terms & Conditions</CustomLink>
          <CustomLink to="/privacy">Privacy</CustomLink>
          <CustomLink to="/guidelines">Guildlines</CustomLink>
        </ul>
      </nav>
    </>
  );
}

function CustomLink({ to, children, ...props }) {
  const resolvedPath = useResolvedPath(to);
  const isActive = useMatch({ path: resolvedPath.pathname, end: true });
  return (
    <li className={isActive ? "active" : ""}>
      <Link to={to} {...props}>
        {children}
      </Link>
    </li>
  );
}
